var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "th",
    { class: _vm.col.class, style: _vm.col.style },
    [
      _vm._t("default"),
      _vm._v(" "),
      Array.isArray(_vm.col.sort)
        ? _c("span", { staticClass: "dropdown" }, [
            _c(
              "a",
              {
                class: ["dropdown-toggle", { disabled: _vm.disabled }],
                attrs: { role: "button", "data-toggle": "dropdown" },
              },
              [
                _vm._v("\n\t\t\t" + _vm._s(_vm.col.label) + " "),
                _c("debug", [
                  _c("b", [
                    _vm._v(
                      "[" + _vm._s(_vm.col.debugLabel || _vm.col.key) + "]"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "caret" }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "dropdown-menu", attrs: { role: "menu" } },
              _vm._l(_vm.col.sort, function (o) {
                return _c(
                  "li",
                  { key: o.value, class: { disabled: _vm.disabled } },
                  [
                    _c(
                      "a",
                      {
                        class: ["sort", { disabled: _vm.disabled }],
                        attrs: { role: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.changeSort(o.value)
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(o.label) + " "),
                        _c("Debug", [
                          _c("b", [_vm._v("[" + _vm._s(o.value) + "]")]),
                        ]),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm.col.sort
        ? _c(
            "a",
            {
              class: ["sort", { disabled: _vm.disabled }],
              attrs: { role: "button", title: _vm.col.title },
              on: {
                click: function ($event) {
                  return _vm.changeSort(_vm.col.sort)
                },
              },
            },
            [
              _vm._v("\n\t\t" + _vm._s(_vm.col.label) + " "),
              _c("debug", [
                _c("b", [
                  _vm._v("[" + _vm._s(_vm.col.debugLabel || _vm.col.key) + "]"),
                ]),
              ]),
            ],
            1
          )
        : _c(
            "span",
            { attrs: { title: _vm.col.title } },
            [
              _vm._v(_vm._s(_vm.col.label) + " "),
              _c("debug", [
                _c("b", [
                  _vm._v("[" + _vm._s(_vm.col.debugLabel || _vm.col.key) + "]"),
                ]),
              ]),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }